import { render } from "./ItemTypeMenuTable.vue?vue&type=template&id=45a6bb13"
import script from "./ItemTypeMenuTable.vue?vue&type=script&lang=js"
export * from "./ItemTypeMenuTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__